/* @flow */
import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Subheader from 'material-ui/Subheader';

import FilterDisplay from './FilterDisplay';

type Props = {
  handleFilter: () => void,
  handleResetFilter: () => void,
  fieldMap: Object,
  values: Object,
  children?: mixed, // eslint-disable-line react/require-default-props
};

type State = {
  open: boolean,
};

export default class Filters extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleSubmit = () => {
    this.setState({ open: false });
    this.props.handleFilter();
  };

  handleCancel = () => {
    this.setState({ open: false });
    this.props.handleResetFilter();
  };

  render() {
    const actions = [
      <FlatButton label="Cancel" onClick={this.handleCancel} />,
      <FlatButton
        label="Submit"
        primary
        keyboardFocused
        onClick={this.handleSubmit}
      />,
    ];

    const { open } = this.state;
    const { fieldMap, values } = this.props;

    return (
      <div>
        <div>
          <span style={{ padding: 10 }}>
            <Subheader>Applied Filters</Subheader>
            <FilterDisplay fieldMap={fieldMap} values={values} open={open} />
          </span>
          <br />
          <RaisedButton label="Filters" primary onClick={this.handleOpen} />
        </div>
        <Dialog
          title="Filters"
          actions={actions}
          modal
          open={this.state.open}
          onRequestClose={this.handleCancel}
        >
          {this.props.children}
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/components/Filters.js